import React, { useState } from 'react';
import './AisheCertificate.css'; // Link the CSS file for styling

const AisheCertificate = () => {
   
    const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);

    const aisheCertificatePdfUrl = "/aische-certificate_page-0001.pdf";

    const openPdfViewer = (pdfUrl) => {
        setSelectedPdfUrl(pdfUrl);
    };

    const closePdfViewer = () => {
        setSelectedPdfUrl(null);
    };

    return (
        <div className="aishe-certificate-container">
            <h2>AISHE Certificate</h2>
            <p className="aishe-certificate-intro-text">
                
            </p>

            <div className="aishe-document-section">
                <button
                    className="view-document-btn"
                    onClick={() => openPdfViewer(aisheCertificatePdfUrl)}
                >
                    Click to View Document
                </button>
            </div>

            
            {selectedPdfUrl && (
                <div className="fullscreen-overlay" onClick={closePdfViewer}>
                    <button className="close-button" onClick={closePdfViewer}>&times;</button>
                    <iframe
                        className="pdf-viewer-iframe"
                        src={`${selectedPdfUrl}#toolbar=0`}
                        title="AISHE Certificate"
                        frameBorder="0"
                    />
                </div>
            )}
        </div>
    );
};

export default AisheCertificate;